import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

/**
 * Extracts a value from a URL query parameter style string based on a key
 * @param {string} key - The key to look up in the key-value string
 * @param {string} keyValueString - String in format "key1=value1&key2=value2" where values are URL encoded
 * @returns {string|null} The decoded value for the given key, or null if key not found
 * @example
 * // Returns "App Only"
 * getKeyValueText("App Only", "App Only=App%20Only&In-Store Only=In-Store%20Only")
 */
export var getKeyValueText = function getKeyValueText(key, keyValueString) {
  if (!keyValueString || keyValueString === '') return null;
  var keyValuePairs = keyValueString.split('&');
  var keyValueMap = {};
  keyValuePairs.forEach(function (pair) {
    var _pair$split = pair.split('='),
        _pair$split2 = _slicedToArray(_pair$split, 2),
        k = _pair$split2[0],
        v = _pair$split2[1];

    keyValueMap[k] = decodeURIComponent(v);
  });
  return keyValueMap[key] || null;
};